(function () {
  const OVERLAY_SEL = '.octane-ai-quiz-rendered';

  function getOverlay() {
    return document.querySelector(OVERLAY_SEL);
  }

  function scrollOverlayTop(behavior = 'smooth') {
    const overlay = getOverlay();
    if (!overlay) return;

   
    try {
      overlay.scrollTo({ top: 0, behavior });
    } catch (e) {
      overlay.scrollTop = 0;
    }
  }

  // Detect clicks on Next/Continue/Back inside the overlay
  document.addEventListener('click', function (e) {
    const overlay = getOverlay();
    if (!overlay || !overlay.contains(e.target)) return;

    const btn = e.target.closest('button, a');
    if (!btn) return;

    const label = ((btn.textContent || btn.getAttribute('title') || '').trim()).toLowerCase();

    // Octane uses "CONTINUE" and "Back" (and sometimes Next/Previous)
    const isNav =
      label.includes('continue') ||
      label.includes('next') ||
      label.includes('back') ||
      label.includes('previous') ||
      btn.getAttribute('title')?.toLowerCase().includes('back');

    if (!isNav) return;

    // Wait a moment for the next "page" to render, then scroll to top
    setTimeout(() => scrollOverlayTop('smooth'), 120);
  }, true);

  // Backup: when Octane changes content, scroll to top
  // (Prevents weird cases where nav isn't a normal button click)
  const boot = () => {
    const overlay = getOverlay();
    if (!overlay) return;

    const mo = new MutationObserver(() => {
      clearTimeout(window.__octOverlayScrollT);
      window.__octOverlayScrollT = setTimeout(() => scrollOverlayTop('auto'), 80);
    });

    mo.observe(overlay, { childList: true, subtree: true });
  };

  // Overlay may be injected after page load
  const waitForOverlay = () => {
    const overlay = getOverlay();
    if (overlay) return boot();
    setTimeout(waitForOverlay, 300);
  };

  waitForOverlay();
})();